import React from 'react';
import { AlertTriangle } from 'lucide-react';
import i18next from 'i18next';
import { reportError } from '../../utils/errorReporting';

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[GlobalErrorBoundary]', error, errorInfo.componentStack);
    }
    reportError(error, errorInfo, { boundary: 'GlobalErrorBoundary' });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 p-8">
          <div className="bg-white rounded-xl shadow-lg p-12 max-w-lg text-center">
            <AlertTriangle size={64} className="text-red-500 mx-auto mb-6" />
            <h1 className="text-2xl font-bold text-gray-900 mb-3">
              {i18next.t('applicationError')}
            </h1>
            <p className="text-gray-600 mb-8">
              {i18next.t('applicationErrorMsg')}
            </p>
            <button
              onClick={this.handleReload}
              className="px-8 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors"
            >
              {i18next.t('reloadApp')}
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
